import { createFromIconfontCN } from '@ant-design/icons';

/**
 * 阿里云图标库组件
 * 使用方式：<IconFont type="icon-xxx" />
 */
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_5034497_4fbiwpesx6y.js',
});

export default IconFont; 